import React, { useState, useEffect } from 'react';
import { HIDE, REFRESHED_ON, EMAIL, TWITTER, REDDIT, YOUTUBE, FACEBOOK } from './const';
import { useDispatch, useSelector } from 'react-redux';
import { FORCE_UPDATE, SHUFFLE_APPS, SHOW_LEADERS, SELECT_APP } from './REDUX/actions';
import _ from 'lodash';
import AppLogo512 from '../../BMG-512.png';
import { isOnMobile, scrollClass, getDate, apple, dbget, dbset, canUseLocalStorage } from './utils';
import { getAppInfo } from './info';
import { navigate } from 'hookrouter';
import { PROMPT_TO_INSTALL, APP_URL, USE_ROUTER, MORE_INLINE, FOOTER, DEV_VERSION } from './config';
import './styles.css';
import ContactButton from './COMPONENTS/ContactButton';

const HomePage = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [rect, setRect] = useState();
  const dispatch = useDispatch();
  let { apps } = useSelector(state => state.common);
  const forceUpdate = () => dispatch({ type: FORCE_UPDATE });

  useEffect(() => {
    dbget(REFRESHED_ON, date => {
      if (APP_URL && canUseLocalStorage) {
        const today = getDate();

        if (date !== today) {
          dbset(REFRESHED_ON, today, () => (window.location.href = APP_URL));
          return;
        }
      }

      window.addEventListener('resize', setRect);

      if (!apps) {
        dispatch({ type: SHUFFLE_APPS });
      }

      dispatch({ type: SHOW_LEADERS, op: HIDE });
      return;
    });

    return () => {
      window.removeEventListener('resize', setRect);
    };
  }, [apps, dispatch]);

  useEffect(() => {
    const handleDeferredPrompt = e => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later.
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleDeferredPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleDeferredPrompt);
    };
  }, []);

  const handleApp = app => e => {
    const name = getAppInfo(app, true).name;

    if (USE_ROUTER) {
      navigate(`/${name.toLowerCase()}`);
    } else {
      dispatch({ type: SELECT_APP, app });
    }
  };

  const handleInstall = () => {
    deferredPrompt.prompt();

    // Wait for the user to respond to the prompt
    deferredPrompt.userChoice.then(choiceResult => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the A2HS prompt');
      } else {
        console.log('User dismissed the A2HS prompt');
      }

      setDeferredPrompt(null);
    });
  };

  const handleDismissPropmpt = () => {
    setDeferredPrompt(null);
  };

  const wide = rect && rect.width > 540;
  const widest = rect && rect.width > 770;
  const narrow = !widest && !wide;
  const contactSize = narrow ? '24' : '30';
  const contactStyle = { margin: '10px 10px 0 0' };

  return (
    <div className="page-root">
      <div
        className="home-page"
        ref={e => {
          const r = e ? e.getBoundingClientRect() : null;

          if (r && (!rect || r.width !== rect.width || r.height !== rect.height)) {
            setRect(r);
            forceUpdate();
          }
        }}>
        <div className="title" style={{ gridArea: '1/1' }}>
          <img src={AppLogo512} width="100px" alt="BMG logo" />
          <span style={{ margin: '0.2em 0 0.5em' }}>Beautiful Mind Games</span>
        </div>
        <div className={scrollClass} style={{ gridArea: '2/1' }}>
          <div
            className="home-apps"
            style={{ padding: `${apple ? '0 10px' : 0}`, grid: `${widest ? 'auto / auto auto auto' : wide ? 'auto / auto auto' : ''}` }}>
            {_.map(apps || [], (app, i) => {
              const { name: appName, background, backgroundImage, icon } = getAppInfo(app);
              return (
                <div key={app} className="app-option" style={{ background, backgroundImage }} onClick={handleApp(app)}>
                  <img src={icon} width="60px" alt={`${appName} logo`} />
                  <span style={{ marginLeft: '10px' }}>{appName}</span>
                </div>
              );
            })}
            {MORE_INLINE && <div className="more-games">{MORE_INLINE}</div>}
          </div>
        </div>
        <div className="title bmg-com-wrapper">
          {FOOTER ? (
            <div style={{ fontSize: '14px', opacity: 0.8 }}>{FOOTER}</div>
          ) : (
            <a href={APP_URL} className={`bmg-com ${APP_URL ? '' : 'bmg-com-disabled'}`}>
              <span>BEAUTIFUL</span>
              <span className="bmg-com-mind">MIND</span>
              <span>GAMES.COM</span>
            </a>
          )}
        </div>
      </div>
      <div className="home-contact">
        <ContactButton size={contactSize} service={EMAIL} url={`mailto:${EMAIL}`} style={contactStyle} />
        <ContactButton size={contactSize} service={TWITTER} style={contactStyle} />
        <ContactButton size={contactSize} service={FACEBOOK} style={contactStyle} />
        <ContactButton size={contactSize} service={REDDIT} style={contactStyle} />
        <ContactButton size={contactSize} service={YOUTUBE} style={contactStyle} solid />
      </div>
      {PROMPT_TO_INSTALL && deferredPrompt && !isOnMobile() && (
        <div className="install-prompt">
          <img src={AppLogo512} width="30px" alt="BMG logo" onClick={handleInstall} />
          <span style={{ marginLeft: '10px' }} onClick={handleInstall}>
            Install Beautiful Mind Games on this device
          </span>
          <span className="install-prompt-x" onClick={handleDismissPropmpt}>
            ×
          </span>
        </div>
      )}
      <div className="home-version">{DEV_VERSION}</div>
    </div>
  );
};

export default HomePage;
